import { createApiHooks } from '@apis/next/common';
import { RegistrationForm } from '@models/next/User';
import { z } from 'zod';

export const userApis = createApiHooks('', [
  {
    path: '/registration',
    method: 'post',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: RegistrationForm,
      },
    ],
    response: z.unknown(),
  },
]);
